import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Defines the query structure for fetching organizations list (with brands).
 */
export const GET_ORGANIZATIONS = gql`
  query Organizations($params: OrganizationPaginationParamsInput!) {
    organizations(params: $params) {
      total
      page
      limit
      items {
        organizationId
        organizationKey
        organizationName
        organizationDisplayName
        organizationDescription
        organizationLogoUrl
        organizationIsActive
        organizationCreatedAt
        organizationUpdatedAt
        organizationDeletedAt
        organizationCreatedBy
        organizationUpdatedBy
        organizationDeletedBy
        brands {
          brandId
          brandKey
          brandName
          brandDisplayName
          brandDescription
          brandLogoUrl
          brandIsActive
          brandCreatedAt
          brandUpdatedAt
          brandDeletedAt
          brandCreatedBy
          brandUpdatedBy
          brandDeletedBy
          brandFeaturesCount
        }
      }
    }
  }
`;
